export default "__VITE_ASSET__Cxg6v4G5__"